import type { TablesSummary } from '@/api/dashboardSummary';

/** Dashboard requests limit=0, so every monitored table must be represented. */
export function tableSummaryStatus(data: TablesSummary | undefined) {
  const tables = [...(data?.sample ?? []), ...(data?.clean_sample ?? [])];
  const noFrames = data?.has_frames_today === false;
  const dirtyCount = noFrames ? 0 : Math.max(data?.dirty_count ?? 0,
    tables.filter(table => table.state === 'dirty').length);
  const unavailable = !data || noFrames || data.total === 0 || tables.length < data.total
    || tables.some(table => !table.state || table.state === 'no_data');
  const rechecking = tables.some(table => table.recheck_pending);
  const uncertain = rechecking || tables.some(table => table.state === 'unknown');
  const tone = dirtyCount > 0 ? 'attention' : unavailable || uncertain ? 'none' : 'ok';
  return { tables, noFrames, dirtyCount, unavailable, uncertain, rechecking, tone } as const;
}
